import { FC, useEffect, useState } from "react";

import { useRouter } from "next/router";

import { Layout, theme } from "antd";

import MetaTag from "./metaTag";

import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Spinner from "@/components/Spinner";

import useLayoutStore from "@/store/useLayoutStore";

import { ILayout } from "@/types";
import SidebarMobile from "@/components/SidebarMobile";
import useWindowResize, { useWindowResizeTablet } from "@/hooks/useWindowResize";
// import UserGuide from "@/components/UserGuide";

const { Content } = Layout;

const LayoutDashboard: FC<ILayout> = ({
  children,
  title = "",
  isLoader = false,
}) => {
  const isMobile = useWindowResize();
  const isTablet = useWindowResizeTablet();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const router = useRouter();

  const [isLoaded, setIsLoaded] = useState(false);

  const isLoaders = useLayoutStore.useIsLoader();
  const setTitle = useLayoutStore.useSetTitle();
  const collapsed = useLayoutStore.useCollapsed();

  useEffect(() => {
    setIsLoaded(true);
    setTitle(title);
  }, [router, title]);

  if(!isLoaded) return null;

  return (
    <>
      <MetaTag />
      <Layout className="mc-scrollbar">
        <Sidebar />
        <SidebarMobile />
        <Layout
          style={{
            marginLeft: (isMobile || isTablet) ? 0 : collapsed ? 80 : 230,
            transition: "ease .2s",
          }}
        >
          <Header />
          <Content
            style={{
              margin: (isMobile || isTablet) ? "24px 0" : 0,
              padding: (isMobile || isTablet) ? "8px 16px" : 30,
              minHeight: "calc(100vh - 112px)",
              background: colorBgContainer,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>

      {(isLoader || isLoaders) && (
        <div
          className="fixed w-full h-screen flex justify-center items-center top-0 left-0"
          style={{ zIndex: 9999, backgroundColor: "rgb(38 38 38 / .5)" }}
        >
          <Spinner size="lg" isTextLoading={false} />
        </div>
      )}
    </>
  );
};

export default LayoutDashboard;
